import * as React from 'react'

import { Control, FieldPath, FieldValues, useController } from 'react-hook-form'

import {
  ErrorText,
  Grid,
  NumberInputControl,
  NumberInputDecrementTrigger,
  NumberInputIncrementTrigger,
  NumberInputInput,
  NumberInputRoot,
  Stack,
  Text,
} from '@enechain/ecloud-designsystem'

type Props<T extends FieldValues, K extends FieldPath<T>> = {
  name: K
  control: Control<T>
  unit: string
  step?: number
  placeholder?: string
}

export const FormNumberInputWithUnit = <
  T extends FieldValues,
  K extends FieldPath<T>,
>({
  name,
  control,
  unit,
  placeholder,
  step = 0.01,
}: Props<T, K>): React.ReactElement => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    control,
  })

  return (
    <Stack gap="1">
      <Grid
        maxWidth="15rem"
        gridTemplateColumns="4fr 1fr"
        alignItems="center"
        gridGap="4"
      >
        <NumberInputRoot
          step={step}
          name={field.name}
          value={(field.value as string | undefined) ?? ''}
          onValueChange={(details) => field.onChange(details.value)}
          onBlur={field.onBlur}
        >
          <NumberInputInput
            ref={field.ref}
            textAlign="right"
            paddingRight="10"
            placeholder={placeholder}
          />
          <NumberInputControl>
            <NumberInputIncrementTrigger />
            <NumberInputDecrementTrigger />
          </NumberInputControl>
        </NumberInputRoot>
        <Text>{unit}</Text>
      </Grid>
      {error?.message !== undefined && <ErrorText>{error.message}</ErrorText>}
    </Stack>
  )
}
